import Tooltip from "@material-ui/core/Tooltip";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import carecentreTokens from "../../tokens";

const t = carecentreTokens;

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: t.color.primaryDeep,
    color: "#FFFFFF",
    borderRadius: t.radius.sm,
    boxShadow: t.shadow.md,
    padding: "8px 12px",
    maxWidth: 300,
    fontSize: 12,
    lineHeight: 1.45,
    fontWeight: 500,
    fontFamily: t.font.body,
  },
  arrow: {
    color: t.color.primaryDeep,
  },
});

/**
 * Rich tooltip body — title plus muted detail lines.
 */
export const CcTooltipContent = ({ title, lines = [] }) => (
  <span style={{ display: "flex", flexDirection: "column", gap: 4 }}>
    {title ? (
      <span style={{ fontWeight: 700, lineHeight: 1.35 }}>{title}</span>
    ) : null}
    {lines.map((line) => (
      <span key={line} style={{ opacity: 0.88, lineHeight: 1.4 }}>
        {line}
      </span>
    ))}
  </span>
);

/**
 * CcTooltip — Carecentre-themed MUI tooltip (navy panel, soft shadow).
 */
const CcTooltip = ({
  title,
  placement = "top",
  enterDelay = 200,
  children,
  ...rest
}) => {
  const classes = useStyles();

  if (title == null || title === "") {
    return children;
  }

  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      enterDelay={enterDelay}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      {...rest}
    >
      <span style={{ display: "inline-flex", maxWidth: "100%" }}>
        {children}
      </span>
    </Tooltip>
  );
};

export default CcTooltip;
